export default {
  /* file transfer related */
  CHUNK: 'chunk',
  JOIN: 'join',
  USER_JOIN: 'user-join',
  USER_LEAVE: 'user-leave',
  FILE_INIT: 'file-init',
  FILE_STATUS: 'file-status',
  FILE_TORRENT: 'file-torrent',

  /* error related */
  ERR_SAME_NAME: 'ERR_SAME_NAME',
  ERR_CONN_CLOSED: 'ERR_CONN_CLOSED',
  ERR_LARGE_FILE: 'ERR_LARGE_FILE',

  /* service worker features related */
  SW_LOAD_FILES: 'sw-load-files',
  SW_SHARE_READY: 'sw-share-ready',
};